import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Heading, Spinner, Text, VStack } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { BusinessUnitForm } from '@/components/forms/BusinessUnitForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditBusinessUnitPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const businessUnitId = id ? Number(id) : undefined
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (!businessUnitId || Number.isNaN(businessUnitId)) {
      navigate('/organization/business-units', { replace: true })
      return
    }
    setIsValidating(false)
  }, [businessUnitId, navigate])

  if (isValidating || !businessUnitId) {
    return (
      <AdminLayout>
        <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
          <Card h="full" display="flex" flexDirection="column">
            <CardBody flex="1" display="flex" alignItems="center" justifyContent="center">
              <VStack spacing={4}>
                <Spinner size="xl" color="blue.500" />
                <Text>Loading...</Text>
              </VStack>
            </CardBody>
          </Card>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit Business Unit</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update business unit details and hierarchy assignment
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <BusinessUnitForm
              businessUnitId={businessUnitId}
              onSuccess={() => navigate('/organization/business-units')}
              onCancel={() => navigate('/organization/business-units')}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}

